import {directive as onClickaway} from 'vue-clickaway';
import {mapActions, mapGetters, mapMutations} from 'vuex';

import VideoPlayer from "@/components/video-player/index.vue";
import Notice from '@/components/features/notice/index.vue';
import AdditionalMaterials from '@/components/features/additional-materials/index.vue';
import SpeakersMobile from '@/components/atoms/speakers-education-mobile/index.vue';
import {seo} from '@/mixins/seo'

export default {
    name: 'education-detail',
    mixins: [seo],
    directives: {
        onClickaway: onClickaway,
    },
    props: {},
    data() {
        return {
            active: false,
            value: '',
        }
    },
    components: {
        VideoPlayer,
        Notice,
        AdditionalMaterials,
        SpeakersMobile
    },
    beforeRouteLeave(to, from, next) {
        if (!this.$route.name.includes(to.name)) {
            this.changeCategory()
        }
        next();
    },
    computed: {
        ...mapGetters({
            currentItem: 'education/currentItem',
            isLoading: 'education/isCurrentItemLoading',
        }),
    },
    created() {
        this.fetchContent({
            slug: this.$route.params.slug,
            educationType: this.$route.meta.breadcrumbs[1].name
        }).then(() => {
            Object.assign(this.seo, this.currentItem.seo.data)
            this.$emit('updateHead')
        })
    },
    methods: {
        ...mapActions({
            fetchContent: 'education/GET_LIST_ITEM'
        }),
        ...mapMutations({
            setContent: 'education/SET_ITEM',
            changeCategory: 'education/CHANGE_CATEGORY',
            setCategories: 'education/SET_CATEGORIES',
        }),
    },
    destroyed() {
        this.setContent(null)
    }
}
